import {Component, Host, Input, OnInit} from '@angular/core';
import {AppModalService} from 'app/services/appModal.service';
import {ChatEditModalComponent} from 'app/components/shared/chatModal/components/chatEditModal/item';
import {ChatInfoModalComponent} from 'app/components/shared/chatModal/components/chatInfoModal/item';
import {ChatWrapperComponent} from '../chat-wrapper/item';
import {UserModelService} from "../../../../models/user-model.service";

@Component({
  selector: 'app-chat-header',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class ChatHeaderComponent implements OnInit {

  chatWrapper: ChatWrapperComponent;
  appModalService: AppModalService;
  userModalService: UserModelService;
  data: any;

  constructor(
    appModalService: AppModalService,
    @Host() chatWrapper: ChatWrapperComponent,
    userModalService: UserModelService
  ) {
    this.chatWrapper = chatWrapper;
    this.appModalService = appModalService;
    this.userModalService = userModalService;
  }

  ngOnInit() {
    if (!this.chatWrapper.group) {
      this.userModalService.getChatPermissions(this.chatWrapper.caseMetadata, (res) => {
        if (res.status) {
          this.data = res.result;
        }
      });
    }
  }

  openActionMenu() {
    this.appModalService.openQuickSelectModal([
      {
        title: 'Информация',
        callback: () => {
          this.openGroupInfoModal();
        }
      },
      {
        title: 'Участники чата',
        callback: () => {
          this.openEditModal();
        }
      },
      {
        title: 'Редактировать информацию',
        callback: () => {
          this.openEditModal();
        }
      },
      {
        title: 'Удалить группу ( для теста )',
        callback: () => {
          this.chatWrapper.group.delete();
        }
      }
    ]);
  }

  openEditModal() {
    this.appModalService.openModal(ChatEditModalComponent, {group: this.chatWrapper.group}, 'half', 'half', (data) => {
      // console.log('Редактировать информацию');
      // if (data?.chatName) {
      //   this.chatWrapper.group.edit({
      //     title: data.chatName
      //   });
      // }
    });
  }

  openGroupInfoModal() {
    this.appModalService.openModal(ChatInfoModalComponent, {group: this.chatWrapper.group}, 'full', 'full', (data) => {
      // console.log('Информация');
    });
  }

  openGroupWorkersModal() {
    // console.log('Участники чата');
  }
}
